import qs from 'qs';

/**
 * This method allows parsing a query string using `qs` and decode any query params that are numbers, booleans, nulls or undefined
 * @param query
 */

export const parseQuery = <T>(query: string): T => {
  return qs.parse(query, {
    decoder(value) {
      if (/^(\d+|\d*\.\d+)$/.test(value)) {
        return parseFloat(value);
      }

      const keywords: Record<string, any> = {
        true: true,
        false: false,
        null: null,
        undefined: undefined,
      };

      if (value in keywords) {
        return keywords[value];
      }

      return decodeURIComponent(value);
    },
  }) as unknown as T;
};
